<template>
  <form class="dropzone dz-cover">
    <font-awesome-icon class="close" :icon="['fas', 'times-circle']" @click.stop="removeAllFiles" v-if="isUpload"/>
    <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
    <div id="dropzone-message" style="display: none">
      <span class="dropzone-title">
        FacebookやTwitterでシェアされたときに画像が途切れないように、<br>
        横760px * 縦400px以上のサイズで、1.91:1の比率を強く推奨しております。
      </span>
      <span class="dropzone-info">
        ファイルをドロップダウンまたはクリックでファイル選択
      </span>
    </div>
  </form>
</template>

<script>
import Dropzone from 'dropzone'
import '../../../node_modules/dropzone/dist/dropzone.css'
import apig from '@/apig'
import store from '@/store'

Dropzone.autoDiscover = false

export default {
  name: 'dropzone_cover',
  props: [ 'smartthonId' ],
  data () {
    return {
      isUpload: false
    }
  },
  computed: {
    smartthon () {
      return store.getters.smartthon
    }
  },
  methods: {
    removeAllFiles () {
      this.dropzone.removeAllFiles()
      this.isUpload = false
      this.$emit('data', {
        type: 'cover',
        isUpload: this.isUpload
      })
    }
  },
  mounted () {
    const vm = this

    let options = {
      // The URL will be changed for each new file being processing
      url: '/',

      // Since we're going to do a `PUT` upload to S3 directly
      method: 'put',

      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending (file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },

      maxFiles: 1,
      dictMaxFilesExceeded: 'アップロードは1ファイルのみです',
      acceptedFiles: 'image/*',
      dictInvalidFileType: 'アップロードは画像ファイルのみです',
      maxFilesize: 3.0,
      dictFileTooBig: 'アップロードは3MBまでです。',

      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',

      // Customize the wording
      dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML,

      // previewTemplate: '<div></div>',

      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,

      // Here we request a signed upload URL when a file being accepted
      accept (file, done) {
        let additionalParams = {
          queryParams: {
            type: 'smartthon_cover',
            smartthonId: vm.smartthonId
          }
        }
        apig.getSignedURL(file, additionalParams)
          .then((res) => {
            file.uploadURL = res.data.url
            done()

            setTimeout(() => {
              vm.dropzone.processFile(file)
              vm.isUpload = true
              vm.$emit('data', {
                type: 'cover',
                isUpload: vm.isUpload,
                coverId: res.data.uuid
              })
            })
          })
          .catch((err) => {
            console.log(err)
            done('アップロードに失敗しました', err)
          })
      }
    }

    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el, options)

    // Set signed upload URL for each file
    vm.dropzone.on('processing', (file) => {
      vm.dropzone.options.url = file.uploadURL
    })
  }
}
</script>

<style lang="stylus" scoped>
primaryBlue = #3498db

.dropzone
  padding 0

.dz-cover
  height 460px!important
  width 100%!important

form.dropzone
  transition all 0.2s linear
  border 2px dashed #ccc
  background-color #fafafa
  min-height initial
  &:hover
    border-color primaryBlue
    .dz-message
      .dropzone-title
        color primaryBlue
  .dz-message
    color #666
    display -webkit-flex
    display flex
    -webkit-align-items center
    align-items center
    -webkit-justify-content center
    justify-content center
    span
      line-height 1.8
      font-size 13px
      letter-spacing 0.4px
      span.dropzone-title
        display block
        color #888
        font-size 1.25em
        margin 150px 0 80px
      span.dropzone-info
        display block
        color #a8a8a8

</style>



// WEBPACK FOOTER //
// src/components/share/dropzone_cover.vue